(function ($) {
    var self = {
        selectors: {
            carousel: '.carousel-gallery',
            prevButton: '.carousel-prev-button',
            nextButton: '.carousel-next-button',
        },
        initCarousel: function () {
            const $carousel = $(self.selectors.carousel);
            const $prevButton = $(self.selectors.prevButton);
            const $nextButton = $(self.selectors.nextButton);

            if (!$carousel.length) {
                return;
            }

            // Obliczenie kroku przewijania (1/3 szerokości karuzeli)
            const getScrollStep = function() {
                return $carousel.width() / 3;
            };

            // Obsługa kliknięcia przycisku "Następny"
            $nextButton.on('click', function() {
                $carousel.animate({
                    scrollLeft: $carousel.scrollLeft() + getScrollStep()
                }, 300);
            });

            // Obsługa kliknięcia przycisku "Poprzedni"
            $prevButton.on('click', function() {
                $carousel.animate({
                    scrollLeft: $carousel.scrollLeft() - getScrollStep()
                }, 300);
            });
        },
        init: function () {
            self.initCarousel();
        }
    };

    self.init();
})(jQuery);